module.exports = __webpack_public_path__ + "2c7034464503010658489643d9ec44ed.jpg";